import styles from '../base.module.css';

/** The prototype's helper classes (02 §4.1) by their original names, joined for `className`. */
export type BaseClass = 'cell' | 'ctl' | 'stk' | 'qb' | 'pb' | 'upb' | 'upv' | 'ta2' | 'in2' | 'cz' | 'arc' | 'hz' | 'hv'
  | 'addi' | 'wait' | 'wobA' | 'wobB' | 'slL0' | 'slL1' | 'slR0' | 'slR1' | 'picBtn' | 'srOnly' | 'spin' | 'seek'
  | 'gsi-material-button' | 'gsi-material-button-state' | 'gsi-material-button-content-wrapper' | 'gsi-material-button-icon' | 'gsi-material-button-contents';

export function cls(...names: readonly (BaseClass | '' | false | null | undefined)[]): string {
  return names.flatMap((name) => (name ? [styles[name] ?? name] : [])).join(' ');
}
